<template>
  <header class="app-header">
    <section class="d-flex justify-content-between">
      <div class="registration-brand">
        <a href="//www.mforex.pl">
          <img src="images/mBank-logo.svg" />
        </a>
      </div>
      <nav v-if="nav">
        <a :href="'tel:' + cms.headPhoneUrl">
          <img src="images/icons/phone.svg" height="24" />
          <template v-if="windowWidth >= mobileBreakpoint">{{ cms.headPhoneTxt }}</template>
        </a>
        <a :href="'mailto:' + cms.headMail">
          <img src="images/icons/envelope.svg" height="24" />
          <template v-if="windowWidth >= mobileBreakpoint">{{ cms.headMail }}</template>
        </a>
      </nav>
    </section>
  </header>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      /* eslint-disable */
      cms: {
        headMail: HEAD_MAIL,
        headPhoneUrl: HEAD_PHONE_URL,
        headPhoneTxt: HEAD_PHONE_TXT
      }
      /* eslint-enable */
    };
  },
  props: {
    nav: {
      type: Boolean,
      required: false,
      default: true
    }
  },
  computed: {
    ...mapGetters(["windowWidth", "mobileBreakpoint"])
  }
};
</script>

